<template>
<div>
  <aside class="main-content">
    <div class="content">
      <div class="nest-contents">
        <p id="err_message" class="err-message">{{ error }}</p>
        <p>会社名と氏名を入力し登録を完了してください。</p>
        <div class="get-start-input pure-form">
          <form id="form" @submit="signUp">
            <div class="input-form fieldset">
              <div>
                <label for="company-name-input">会社名*</label>
                <input type="text" id="company-name-input" placeholder="株式会社ネットワーク" v-model="form.companyName" required>
              </div>
              <div>
                <label for="last-name-input">氏名*</label>
                <div class="input-row">
                  <input type="text" id="last-name-input" placeholder="山田" v-model="form.lastName" required>
                  <input type="text" id="first-name-input" placeholder="太郎" v-model="form.firstName" required>
                </div>
              </div>
              <div>
                <label for="last-name-kana-input">氏名（カナ）*</label>
                <div class="input-row">
                  <input type="text" id="last-name-kana-input" placeholder="ヤマダ" v-model="form.lastNameKana" required>
                  <input type="text" id="first-name-kana-input" placeholder="タロウ" v-model="form.firstNameKana" required>
                </div>
              </div>
            </div>
            <button class="pure-button pure-button-primary">登録</button>
          </form>
        </div>
      </div>
    </div>
  </aside>
</div>
</template>

<script>
export default {
  data() {
    return {
      form:  {
        companyName: "",
        lastName: "",
        firstName: "",
        lastNameKana: "",
        firstNameKana: ""
      },
      email: "",
      uid: "",
      error: ""
    }
  },

  mounted() {
    this.authenticate()
  },

  methods: {
    authenticate() {
      this.email = this.$cookie.get("email")

      if (this.$firebase.auth().isSignInWithEmailLink(window.location.href)) {
        if (!this.email) {
          this.email = window.prompt("再度メールアドレスを入力してください。")
        }
        
        this.$firebase.auth().signInWithEmailLink(this.email, window.location.href)
          .then((result) => {
            this.$store.dispatch("setToken", result.user.ra)
            this.uid = result.user.uid
          })
          .catch(() => {
            this.error = "エラーが発生しました。操作をやり直してください。"
          })
      } else {
        this.error = "リンクが無効です。送信されたメールからリンクを開き直してください。"
      }
    },

    signUp(e) {
      var params = new URLSearchParams()
      params.append("company_name", this.form.companyName)
      params.append("email", this.email)
      params.append("full_name", this.form.lastName + " " + this.form.firstName)
      params.append("full_name_kana", this.form.lastNameKana + this.form.firstNameKana)
      params.append("uid", this.uid)

      this.$http.post("/input_company", params).then((res) => {
          this.$store.dispatch("setUser" , res.data)
          this.$router.push({ name: "transports" })
        }).catch(() => {
          this.error = "エラーが発生しました。操作をやり直してください。"
        })

      e.preventDefault()
    }
  }
}
</script>

<style scoped>
.input-form {
  padding-bottom: 16px;
}

.input-row {
  display: flex;
  width: 97%;
}

#company-name-input {
  width: 97%;
}

#last-name-input, #first-name-input, #last-name-kana-input, #first-name-kana-input {
  width: 50%;
}

#first-name-input, #first-name-kana-input {
  margin-left: 12px;
}

.pure-button-primary{
  background: linear-gradient(125deg, #fff5ee, paleturquoise);
}
</style>
